import {
	Button,
	ConnectionIllustration,
	EmptyTableBody,
	rem,
	StylovyzeTable,
	StylovyzeTableHeaderProps,
	StylovyzeTableRow,
} from '@innovyze/stylovyze';
import { getValue } from '@Selectors';
import { useGlobalization } from '@Translations';
import { addRouteNamespace } from '@Utils/actions';
import React from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

const SystemConnectionsTable = () => {
	const { t } = useGlobalization();
	const history = useHistory();
	const {
		systemConnections: { list, initialized },
	} = useSelector(getValue);

	const headers: StylovyzeTableHeaderProps[] = [
		{ key: 'connection-name', cell: t('Connection Name'), width: 'auto' },
		{ key: 'server-type', cell: t('Server Type'), width: 'auto' },
		{ key: 'connection-type', cell: t('Connection Type'), width: 'auto' },
		{ key: 'weight', cell: t('Server Address'), width: 'auto' },
	];

	const rows: StylovyzeTableRow[] = list.map(item => ({
		key: item.SystemConnectionId,
		dataCy: 'system-connection-row',
		cells: [
			item.connectionName,
			item.serverType,
			item.connectionType,
			item.serverAddress,
		],
		pathToGoWhenClicked: addRouteNamespace(
			`system-connection/${item.SystemConnectionId}`,
		),
	}));

	return (
		<StylovyzeTable
			rows={rows}
			title={t('System Connections')}
			dataCy="system-connections-table"
			minHeight={rem(600)}
			applyBodyPadding={false}
			headers={headers}
			initialized={initialized}
			buttonStyle={{
				color: 'primary',
				variant: 'contained',
			}}
			menuItems={[
				{
					onClick: () =>
						history.push(
							addRouteNamespace('create-system-connection'),
						),
					text: t('New Connection'),
					dataCy: 'newConnectionButton',
				},
			]}
			emptyTableBody={
				<EmptyTableBody
					title={t('There are no System Connections to display')}
					subtitle={t(
						'System connections are established with data sources such as historians.',
					)}
					icon={<ConnectionIllustration />}
					color={'#4A6067'}
					dataCy={'system-connection-empty-table'}
					CTA={
						<Button
							variant="contained"
							color="primary"
							onClick={() =>
								history.push(
									addRouteNamespace(
										'create-system-connection',
									),
								)
							}>
							Create System Connection
						</Button>
					}
				/>
			}
		/>
	);
};

export default SystemConnectionsTable;
